import React from 'react'
import PropTypes from 'prop-types'

import TextInputWithCharactersLeft from 'components/TextInputWithCharactersLeft'
import {
  StyledTextarea,
  StyledSelect,
  StyledCheckbox,
  StyledDayPicker,
  StyledInput,
} from './InputStyle'

const Input = props => {
  const { type, showCharactersLeft, ...rest } = props
  const propsWithoutShowCharactersLeft = {
    ...rest,
    type,
  }

  if (type === 'textarea') {
    return <StyledTextarea {...propsWithoutShowCharactersLeft} />
  }

  if (type === 'select') {
    return <StyledSelect {...propsWithoutShowCharactersLeft} />
  }

  if (type === 'checkbox') {
    return <StyledCheckbox {...propsWithoutShowCharactersLeft} />
  }

  if (type === 'daypicker') {
    return <StyledDayPicker {...propsWithoutShowCharactersLeft} />
  }

  if (type === 'file') {
    const fileInputProps = {
      ...propsWithoutShowCharactersLeft,
      value: undefined,
    }

    return <StyledInput {...fileInputProps} />
  }

  if (showCharactersLeft) {
    return <TextInputWithCharactersLeft {...propsWithoutShowCharactersLeft} />
  }

  return <StyledInput {...propsWithoutShowCharactersLeft} />
}

Input.propTypes = {
  type: PropTypes.string,
  reverse: PropTypes.bool,
  height: PropTypes.number,
  invalid: PropTypes.bool,
  showCharactersLeft: PropTypes.bool,
}

Input.defaultProps = {
  type: 'text',
  height: 40,
}

export default Input
